export default __webpack_public_path__ + "static/media/Group 818.b4ab30f3.png";